import './checkbox.svelte.css';
/* src\components\pixel\checkbox.svelte generated by Svelte v3.55.1 */
import {
	SvelteComponent,
	add_render_callback,
	append,
	attr,
	binding_callbacks,
	create_in_transition,
	detach,
	element,
	init,
	insert,
	listen,
	noop,
	run_all,
	safe_not_equal,
	set_data,
	set_style,
	space,
	text as text_1,
	transition_in
} from "../../../_snowpack/pkg/svelte/internal.js";

import { onMount, createEventDispatcher } from '../../../_snowpack/pkg/svelte.js';
import { fade } from '../../../_snowpack/pkg/svelte/transition.js';

function create_if_block_1(ctx) {
	let div;
	let t;

	return {
		c() {
			div = element("div");
			t = text_1(/*text*/ ctx[1]);
			attr(div, "class", "label");
			set_style(div, "padding-top", "2px");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			append(div, t);
		},
		p(ctx, dirty) {
			if (dirty & /*text*/ 2) set_data(t, /*text*/ ctx[1]);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (38:12) {#if checked}
function create_if_block(ctx) {
	let span;
	let span_intro;

	return {
		c() {
			span = element("span");
			span.textContent = "check";
			attr(span, "class", "material-symbols-outlined");
		},
		m(target, anchor) {
			insert(target, span, anchor);
		},
		i(local) {
			if (!span_intro) {
				add_render_callback(() => {
					span_intro = create_in_transition(span, fade, {});
					span_intro.start();
				});
			}
		},
		o: noop,
		d(detaching) {
			if (detaching) detach(span);
		}
	};
}

function create_fragment(ctx) {
	let link;
	let t0;
	let div1;
	let label;
	let t1;
	let input;
	let t2;
	let div0;
	let div0_class_value;
	let mounted;
	let dispose;
	let if_block0 = /*text*/ ctx[1] && create_if_block_1(ctx);
	let if_block1 = /*checked*/ ctx[0] && create_if_block(ctx);

	return {
		c() {
			link = element("link");
			t0 = space();
			div1 = element("div");
			label = element("label");
			if (if_block0) if_block0.c();
			t1 = space();
			input = element("input");
			t2 = space();
			div0 = element("div");
			if (if_block1) if_block1.c();
			attr(link, "rel", "stylesheet");
			attr(link, "href", "https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@48,700,0,0");
			attr(input, "type", "checkbox");
			input.checked = /*checked*/ ctx[0];
			attr(input, "class", "svelte-1fl6xmz");
			attr(div0, "class", div0_class_value = "checkmarkcontainer " + (/*checked*/ ctx[0] ? "checked" : ""));
			attr(label, "class", "control svelte-1fl6xmz");
			attr(div1, "class", "checkbox");
			attr(div1, "style", /*style*/ ctx[2]);
		},
		m(target, anchor) {
			append(document.head, link);
			insert(target, t0, anchor);
			insert(target, div1, anchor);
			append(div1, label);
			if (if_block0) if_block0.m(label, null);
			append(label, t1);
			append(label, input);
			/*input_binding*/ ctx[7](input);
			append(label, t2);
			append(label, div0);
			if (if_block1) if_block1.m(div0, null);

			if (!mounted) {
				dispose = [
					listen(input, "click", /*click_handler*/ ctx[6]),
					listen(input, "focus", /*focus_handler*/ ctx[8]),
					listen(input, "focusout", /*focusout_handler*/ ctx[9])
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (/*text*/ ctx[1]) {
				if (if_block0) {
					if_block0.p(ctx, dirty);
				} else {
					if_block0 = create_if_block_1(ctx);
					if_block0.c();
					if_block0.m(label, t1);
				}
			} else if (if_block0) {
				if_block0.d(1);
				if_block0 = null;
			}

			if (dirty & /*checked*/ 1) {
				input.checked = /*checked*/ ctx[0];
			}

			if (/*checked*/ ctx[0]) {
				if (if_block1) {
					if (dirty & /*checked*/ 1) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div0, null);
				}
			} else if (if_block1) {
				if_block1.d(1);
				if_block1 = null;
			}

			if (dirty & /*checked*/ 1 && div0_class_value !== (div0_class_value = "checkmarkcontainer " + (/*checked*/ ctx[0] ? "checked" : ""))) {
				attr(div0, "class", div0_class_value);
			}

			if (dirty & /*style*/ 4) {
				attr(div1, "style", /*style*/ ctx[2]);
			}
		},
		i(local) {
			transition_in(if_block1);
		},
		o: noop,
		d(detaching) {
			detach(link);
			if (detaching) detach(t0);
			if (detaching) detach(div1);
			if (if_block0) if_block0.d();
			/*input_binding*/ ctx[7](null);
			if (if_block1) if_block1.d();
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let { text = null } = $$props;
	let { style = "" } = $$props;
	let { checked = false } = $$props;
	let { name = null } = $$props;
	let inputField;
	let dispatch = createEventDispatcher();

	onMount(() => {
		if (inputField) {
			//console.log("SetTimeout...");
			setTimeout(
				() => {
					//console.log("checkbox value " + text, inputField.checked);
					$$invalidate(0, checked = inputField.checked === true);
				},
				300
			);
		}
	});

	const click_handler = e => {
		$$invalidate(0, checked = !checked);
	};

	function input_binding($$value) {
		binding_callbacks[$$value ? 'unshift' : 'push'](() => {
			inputField = $$value;
			$$invalidate(4, inputField);
		});
	}

	const focus_handler = () => {
		dispatch("focus", { field: name ? name : text });
	};

	const focusout_handler = () => {
		dispatch("focusout", { field: name ? name : text });
	};

	$$self.$$set = $$props => {
		if ('text' in $$props) $$invalidate(1, text = $$props.text);
		if ('style' in $$props) $$invalidate(2, style = $$props.style);
		if ('checked' in $$props) $$invalidate(0, checked = $$props.checked);
		if ('name' in $$props) $$invalidate(3, name = $$props.name);
	};

	return [
		checked,
		text,
		style,
		name,
		inputField,
		dispatch,
		click_handler,
		input_binding,
		focus_handler,
		focusout_handler
	];
}

class Checkbox extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, { text: 1, style: 2, checked: 0, name: 3 });
	}
}

export default Checkbox;